// @flow
import React from "react";
import PropTypes from "prop-types";
import enhanceWithClickOutside from "react-click-outside";
import _ from "lodash";
import Button from "../button/Button";
import I18n from "../../../i18n/I18n";
import Icon from "../Icon";
import styles from "./Dropdown.scss";

type Props = {
  options: Array<Object>,
  selected: Object,
  onChange: Function,
  smallLabels: boolean,
  selectedLabelSuffix: string
};
// A dropdown component for the Product List view.
class Dropdown extends React.Component {
  state: {
    isOpened: boolean
  };

  static defaultProps: {
    onChange: Function,
    smallLabels: false,
    selectedLabelSuffix: ""
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpened: false
    };
  }

  renderList() {
    return this.props.options.map(item => {
      const checked = _.isEqual(item.value, this.props.selected);
      const iconName = checked ? "tick" : "radio-unchecked";
      return (
        <li
          key={item.key}
          onClick={() => this.onChange(item.value)}
          className={checked ? styles.checked : ""}
        >
          {item.label}
          <Icon name={iconName} className={styles.radio} />
        </li>
      );
    });
  }

  onChange = (newValue: Object) => {
    if (!newValue) {
      return;
    }

    this.setState({ isOpened: !this.state.isOpened }, function() {
      this.props.onChange(newValue);
    });
  };

  close = () => {
    this.setState({ isOpened: false });
  };

  handleButtonClick = () => this.setState({ isOpened: !this.state.isOpened });

  handleClickOutside = () => this.setState({ isOpened: false });

  render() {
    const { options, selected } = this.props;
    const { isOpened } = this.state;
    /* Button is disabled when a label cannot be found */
    const selectedOption = options.find(
      option => selected && _.isEqual(option.value, selected)
    );
    return (
      <div className={styles.container}>
        <Button
          className={styles.filterButton}
          variant="transparent"
          onClick={this.handleButtonClick}
          disabled={selectedOption ? false : true}
        >
          <div>
            <span className={styles.label}>{this.props.label || ""}:</span>
            {selectedOption && selectedOption.label}{" "}
            {this.props.selectedLabelSuffix}
          </div>
          <Icon name={isOpened ? "caret-up" : "caret-down"} />
        </Button>
        {this.state.isOpened && (
          <div
            className={`${styles.popDown} ${
              this.props.smallLabels ? styles.small : ""
            }`}
          >
            <ul>{options && this.renderList()}</ul>
            <Button
              variant="transparent"
              className={styles.btn}
              onClick={this.close}
            >
              {I18n.getText("dropdown.close", {}, "Close")}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Dropdown.defaultProps = {
  onChange: () => null,
  smallLabels: false,
  selectedLabelSuffix: ""
};

export default enhanceWithClickOutside(Dropdown);



// WEBPACK FOOTER //
// ./src/components/common/filterDropdown/Dropdown.js